import { 
  MdDashboard, 
  MdOutlineDashboard,
  MdOutlineReport,
  MdReport
} from 'react-icons/md';
import { 
  FaProjectDiagram,
  FaRegObjectGroup,
  FaUser,
  FaUserCheck
} from 'react-icons/fa';

export const listItems = [
  { 
    name: 'Banners', 
    route: '/', 
    icon: <MdOutlineDashboard size={20} />, 
    selectedIcon: <MdDashboard size={20} /> 
  },
  { 
    name: 'Projects', 
    route: '/projects', 
    icon: <FaRegObjectGroup size={18} />, 
    selectedIcon: <FaProjectDiagram size={18} /> 
  },
  { 
    name: 'Job Openings', 
    route: '/job-openings', 
    icon: <FaUser size={18} />, 
    selectedIcon: <FaUserCheck size={18} /> 
  },
  { 
    name: 'Job Requests', 
    route: '/job-request', 
    icon: <FaUser size={18} />, 
    selectedIcon: <FaUserCheck size={18} /> 
  },
  { 
    name: 'User Report', 
    route: '/user-report', 
    icon: <MdOutlineReport size={18} />, 
    selectedIcon: <MdReport size={18} /> 
  },
];


